import { render } from "./index.vue?vue&type=template&id=e143cb84&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=e143cb84&lang=scss&scoped=true"

import exportComponent from "D:\\Users\\user\\Desktop\\production\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e143cb84"]])

export default __exports__